import {defineMessages} from 'react-intl';

export const DIALOG_OVERLAY_ACCESSIBILITY_TEXT = defineMessages({
  'title': {
    id: 'DialogOverlay.CloseButton.iconTitle',
    defaultMessage: 'Close Button',
    description: 'Accesibility text that lets the user know an "X" image is actually a button'
  },
  'desc': {
    id: 'DialogOverlay.CloseButton.iconDesc',
    defaultMessage: 'Button that closes the open dialog modal.',
    description: 'Accesibility text describing what an "X" button on a dialog modal does'
  }
});

export const KEYBOARD_ESCAPE_CODE = 27;
